import request from "@/utils/request";
// 公告
export function getNoticeList(data) {
  return request({
    url: "/api/party_building/get",
    method: "post",
    data
  });
}
// 文章
export function getScienceList(data) {
  return request({
    url: "/api/science/get",
    method: "post",
    data
  });
}
// 心理咨询
export function getConsultList(data) {
  return request({
    url: "/api/consult/get",
    method: "post",
    data
  });
}
// 心理咨询-详情
export function ConsultDetail(params) {
  return request({
    url: "/api/consult/detail",
    method: "get",
    params
  });
}
